import React from "react";
import TimeIndicator from "./TimeIndicator";

const TimeIndicatorGroup = ({ checkIn, checkOut }) => {
  return (
    <div className="flex lg:flex-row flex-col gap-2.5">
      <TimeIndicator time={checkIn} isEntry={true} />
      <TimeIndicator time={checkOut} isEntry={false} />
    </div>
  );
};

export default TimeIndicatorGroup;
